export function filter(propertyName) {
    return propertyName.indexOf('native_') !== 0;
}
